import { Injector } from '@angular/core';

let injector: Injector;

export const dynamicInjector = (inputInjector?: Injector) => {
  if (!injector && inputInjector) injector = inputInjector;
  return injector;
};
